import './polyfills.ts';

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import {
  EnvironmentConfiguration, environments
} from './app/environment/services/environment.configuration';
import { enableProdMode } from '@angular/core';

/**
 * Setup ngx-bootstrap to use Bootstrap 4
 */
// `window` must be cast to `any` since the compiler does not understand the `__theme` property
(window as any).__theme = 'bs4';

const environment = new EnvironmentConfiguration(environments);
/**
 * Setup Google Analytics; ga loaded from index.html
 */
declare var ga: any;
ga('create', environment.googleAnalytics.id, environment.googleAnalytics.loadType);
/**
 * The below code is commented out and intentionally left here.
 * Google Analytics will tell you that it's required, but it's
 * handled by Angulartics2GoogleAnalytics
 */
// ga('send', 'pageview');

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule);



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/main.ts